var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.user.image)?_c('img',{staticClass:"user-photo",attrs:{"src":_vm.baseUrl + _vm.user.image.thumb}}):_c('v-gravatar',{staticClass:"user-photo",attrs:{"email":_vm.user.email,"default-img":"mp"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }